/**
 * WO DER KOMMENTAR ZU EINER MARKIERTEN STELLE STEHT (PO 28.09.2026:
 * „Kommentarfenster bitte auf selber Höhe wie der Kommentar").
 *
 * Bis hierher ging der Faden UNTER der Stelle auf und deckte die folgenden
 * Zeilen zu — man las den Kommentar, aber nicht mehr den Satz danach. Wie in
 * Word steht er jetzt NEBEN dem Text, auf der Höhe der Stelle:
 *
 *   1. direkt rechts neben der STELLE, wenn dort bis zum Fensterrand Platz ist;
 *   2. sonst unter der Stelle (oder darüber, wenn unten kein Platz ist).
 *
 * Nicht am Rand des Notizfelds: Das Feld ist so breit wie die Seite, der
 * Kasten stand dann eine Bildschirmbreite vom markierten Wort entfernt
 * (PO 28.09.2026: „das Kommentarfeld ist so weit weg vom Text").
 *
 * Rein und ohne DOM, damit die Regel im node-Runner geprüft werden kann.
 */

export type Rechteck = { top: number; left: number; right: number; bottom: number };

/** Luft zwischen Feld bzw. Stelle und dem Kasten. */
export const ABSTAND = 10;
/** Mindestabstand zum Fensterrand. */
export const RAND = 8;

export function platzNebenStelle(p: {
    stelle: Rechteck;
    /** Das Notizfeld — für die Lage nicht mehr maßgeblich, bleibt für Aufrufer. */
    feld?: Rechteck | null;
    breite: number;
    hoehe: number;
    fenster: { breite: number; hoehe: number };
}): { left: number; top: number; seite: "rechts" | "unten" | "oben" } {
    const { stelle, breite, hoehe, fenster } = p;
    // Auf die Höhe der Stelle — geklemmt, damit der Kasten im Bild bleibt.
    const topNeben = Math.max(RAND, Math.min(stelle.top - 6, fenster.hoehe - hoehe - RAND));

    if (stelle.right + ABSTAND + breite <= fenster.breite - RAND) {
        return { left: stelle.right + ABSTAND, top: topNeben, seite: "rechts" };
    }
    const left = Math.max(RAND, Math.min(stelle.left, fenster.breite - breite - RAND));
    const untenPlatz = fenster.hoehe - stelle.bottom - ABSTAND - RAND;
    const nachOben = untenPlatz < hoehe && stelle.top - ABSTAND - RAND > untenPlatz;
    return nachOben
        ? { left, top: Math.max(RAND, stelle.top - hoehe - ABSTAND), seite: "oben" }
        : { left, top: stelle.bottom + ABSTAND, seite: "unten" };
}
